import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  position: relative;
  max-width: 800px; /* Limits the modal width */
  width: 90%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 150px; /* Consistent image size */
    height: 150px;
    object-fit: cover;
    border-radius: 50%; /* Circular image */
    margin-bottom: 1rem; /* Space below the image */
    border: 3px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  }

  h3 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: ${(props) => props.theme.secondary || '#333'};
  }

  h4 {
    font-size: 1.4rem;
    font-weight: normal;
    margin-bottom: 1rem;
    color: ${(props) => props.theme.text || '#555'};
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.text || '#666'};
    line-height: 1.6;
  }

  @media (max-width: 576px) {
    padding: 1rem;

    img {
      width: 100px;
      height: 100px;
    }

    h3 {
      font-size: 1.5rem;
    }

    h4 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;


export const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 2rem;
    font-weight: bold;
    color: var(--color-new-button-active-hover);
    background: transparent;
    border: 2px solid var(--color-new-button-active);
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    text-decoration: none;
   
    &:hover {
        background: var(--color-new-button-active-hover);
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        color: var(--color-button-text);
    }
`;

export const LearnMoreButton = styled.button`
    display: inline-block;
    align-self: center;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: bold;
    color: var(--color-new-button-active-hover);
    background: transparent;
    border: 2px solid var(--color-new-button-active);
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    text-decoration: none;
    margin: 0.5rem;

    &:hover {
        background: var(--color-new-button-active-hover);
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        color: var(--color-button-text);
    }

    &:focus {
        outline: 2px solid var(--color-highlight);
        outline-offset: 2px;
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
        background: var(--color-disabled);
        color: #666;
        cursor: not-allowed;
    }
`;

export const BoardGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem; /* Ensure spacing around the grid container */

   @media (max-width: 986px) {
   padding: 0rem; /* Ensure spacing around the grid container */
    
  }

`;

export const BoardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* Center items on each row */
  gap: 2rem;

  /* Each child (BoardMember) */
  & > * {
    flex: 0 1 calc(33.333% - 2rem); /* Large screens: up to 3 cards per row */
  }

  @media (max-width: 1400px) {
    & > * {
      flex: 0 1 calc(50% - 2rem); /* Medium screens: up to 2 cards per row */
    }
  }

  @media (max-width: 986px) {
    & > * {
      flex: 0 1 100%; /* Small screens: 1 card per row */
    }
  }
`;





export const BoardMember = styled.div`
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  border-radius: 10px;
  padding: 1.5rem;
  margin: 0.5rem 0;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box; /* Includes padding in the total width/height */

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
  }

  img {
    width: 130px;
    height: 130px;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 1rem;
  }

  h4 {
    font-size: 1.4rem;
    font-weight: bold;
    color: ${(props) => props.theme.secondary || '#333'};
    margin-bottom: 0.3rem;
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.text || '#555'};
    margin-bottom: 1rem;
    line-height: 1.6;
  }

  .description {
    font-size: 0.9rem;
    color: #444;
    margin-bottom: 1.5rem;
  }

  button {
    margin-top: auto;
  }
`;

export const LastCardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem; /* Space between the grid and the last card */
  width: 100%;

  @media (max-width: 576px) {
    margin-top: 1rem;
  }
`;

